// extracted by mini-css-extract-plugin
export default {"thankYouPage":"ThankYou_thankYouPage__GlvdF","iconCircle":"ThankYou_iconCircle__gfWFi","popIn":"ThankYou_popIn__nUP07"};